import { cx } from '@linaria/core';
import { Checkmark } from './checkmark.js';
import { Custom } from './custom.js';
import { wrapper, content, modifiers } from './option.style.js';
import { Radio } from './radio.js';
import { optionToId } from './utils/option-to-id.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Option({
  baseId,
  tabIndex,
  value,
  selectedValues,
  disableIcon,
  multiSelect,
  onClick,
  ...props
}) {
  const selected = !!selectedValues?.some(selected => getOptionValue(selected) === getOptionValue(value));
  const toggledIcon = getOptionIcon(value, "toggledIcon") ?? props.toggledIcon;
  const handleClick = () => {
    if (props.disabled) {
      return;
    }
    onClick();
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    jsxs("li", {
      className: cx(wrapper, content, !!toggledIcon && modifiers.custom.className, selected && modifiers.toggled.className),
      tabIndex: tabIndex ?? -1,
      id: optionToId(baseId, value),
      "aria-selected": selected,
      role: "option",
      onClick: handleClick,
      "aria-disabled": props.disabled,
      children: [!disableIcon && (toggledIcon ? /*#__PURE__*/jsx(Custom, {
        toggled: selected,
        toggledIcon: toggledIcon,
        defaultIcon: getOptionIcon(value, "defaultIcon") ?? props.defaultIcon
      }) : multiSelect ? /*#__PURE__*/jsx(Checkmark, {
        toggled: selected
      }) : /*#__PURE__*/jsx(Radio, {
        toggled: selected
      })), getOptionLabel(value)]
    })
  );
}
function getOptionLabel(option) {
  return typeof option === "object" ? option.label : option;
}
function getOptionValue(option) {
  return typeof option === "object" ? option.id : option;
}
function getOptionIcon(option, key) {
  return typeof option === "object" ? option[key] : undefined;
}

export { Option, getOptionLabel, getOptionValue };
//# sourceMappingURL=option.listbox.js.map
